import { opportunitiesApi } from '@modules/opportunities/entities/opportunity/api';
import { listOpportunitiesApiToAppMapper } from '@modules/opportunities/entities/opportunity/api/mappers/bankApplicationStatusApiMapper';
import { toast } from '@huspy/forge/shared';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

const useListOpportunities = (clientId: string | undefined) => {
  const {
    data, isLoading, error, refetch, isRefetching,
  } = useQuery({
    queryKey: ['listOpportunities', clientId],
    queryFn: () => opportunitiesApi.listOpportunities(clientId!),
    enabled: !!clientId,
    select: listOpportunitiesApiToAppMapper,
  });

  useEffect(() => {
    if (error) {
      toast('error', { message: error.message });
    }
  }, [error]);

  return {
    data,
    isLoading,
    error,
    refetch,
    isRefetching,
  };
};

export default useListOpportunities;
